import { ChallengeType } from "../types/BlogTypes";

export enum ContactSector {
	administrationPublique = "Administration publique",
	agenceConseil = "Agences études conseil & service aux entreprises",
	agroAlimentaire = "Agro-alimentaire",
	bailleurs = "Bailleurs",
	banqueAssurance = "Banque/Assurance",
	btp = "BTP",
	chimiePharma = "Chimie/Pharma",
	collectivite = "Collectivité",
	energies = "Énergies",
	immobilier = "Immobilier",
	industrie = "Industrie",
	loisirs = "Loisirs (Sport, tourisme & Culturel)",
	informatiqueEtTelecomsESN = "Informatique et Télécoms & ESN",
	retailTextileHabillement = "Retail, textile & habillement",
	superieur = "Supérieur",
	transportsLogistique = "Transports & Logistique",
}

export enum SalesmenAddress {
	capucine = "capucine@energic.io",
	ph = "ph@energic.io",
	quentin = "quentin@energic.io",
	contact = "contact@energic.io",
	biz = "biz@energic.io",
}

export enum SalesmenHubspotId {
	capucine = "683445716",
	ph = "683435490",
	quentin = "682717403",
}

export const internalChallengeSectorsWithSalesmen: Record<
	ContactSector,
	SalesmenAddress
> = {
	[ContactSector.administrationPublique]: SalesmenAddress.ph,
	[ContactSector.agenceConseil]: SalesmenAddress.quentin,
	[ContactSector.agroAlimentaire]: SalesmenAddress.ph,
	[ContactSector.bailleurs]: SalesmenAddress.capucine,
	[ContactSector.banqueAssurance]: SalesmenAddress.ph,
	[ContactSector.btp]: SalesmenAddress.quentin,
	[ContactSector.chimiePharma]: SalesmenAddress.ph,
	[ContactSector.collectivite]: SalesmenAddress.ph,
	[ContactSector.energies]: SalesmenAddress.capucine,
	[ContactSector.immobilier]: SalesmenAddress.capucine,
	[ContactSector.industrie]: SalesmenAddress.quentin,
	[ContactSector.loisirs]: SalesmenAddress.ph,
	[ContactSector.informatiqueEtTelecomsESN]: SalesmenAddress.capucine,
	[ContactSector.retailTextileHabillement]: SalesmenAddress.ph,
	[ContactSector.superieur]: SalesmenAddress.ph,
	[ContactSector.transportsLogistique]: SalesmenAddress.quentin,
};

export const interCompanyChallengeSectorsWithSalesmen: Record<
	ContactSector,
	SalesmenAddress
> = {
	[ContactSector.administrationPublique]: SalesmenAddress.quentin,
	[ContactSector.agenceConseil]: SalesmenAddress.quentin,
	[ContactSector.agroAlimentaire]: SalesmenAddress.quentin,
	[ContactSector.bailleurs]: SalesmenAddress.quentin,
	[ContactSector.banqueAssurance]: SalesmenAddress.quentin,
	[ContactSector.btp]: SalesmenAddress.quentin,
	[ContactSector.chimiePharma]: SalesmenAddress.quentin,
	[ContactSector.collectivite]: SalesmenAddress.quentin,
	[ContactSector.energies]: SalesmenAddress.quentin,
	[ContactSector.immobilier]: SalesmenAddress.quentin,
	[ContactSector.industrie]: SalesmenAddress.quentin,
	[ContactSector.loisirs]: SalesmenAddress.quentin,
	[ContactSector.informatiqueEtTelecomsESN]: SalesmenAddress.quentin,
	[ContactSector.retailTextileHabillement]: SalesmenAddress.quentin,
	[ContactSector.superieur]: SalesmenAddress.quentin,
	[ContactSector.transportsLogistique]: SalesmenAddress.quentin,
};

export const internalChallengeSectorsWithSalesmenHubspotId: Record<
	ContactSector,
	SalesmenHubspotId
> = {
	[ContactSector.administrationPublique]: SalesmenHubspotId.ph,
	[ContactSector.agenceConseil]: SalesmenHubspotId.quentin,
	[ContactSector.agroAlimentaire]: SalesmenHubspotId.ph,
	[ContactSector.bailleurs]: SalesmenHubspotId.capucine,
	[ContactSector.banqueAssurance]: SalesmenHubspotId.ph,
	[ContactSector.btp]: SalesmenHubspotId.quentin,
	[ContactSector.chimiePharma]: SalesmenHubspotId.ph,
	[ContactSector.collectivite]: SalesmenHubspotId.ph,
	[ContactSector.energies]: SalesmenHubspotId.capucine,
	[ContactSector.immobilier]: SalesmenHubspotId.capucine,
	[ContactSector.industrie]: SalesmenHubspotId.quentin,
	[ContactSector.loisirs]: SalesmenHubspotId.ph,
	[ContactSector.informatiqueEtTelecomsESN]: SalesmenHubspotId.capucine,
	[ContactSector.retailTextileHabillement]: SalesmenHubspotId.ph,
	[ContactSector.superieur]: SalesmenHubspotId.ph,
	[ContactSector.transportsLogistique]: SalesmenHubspotId.quentin,
};

export const interCompanyChallengeSectorsWithSalesmenHubspotId: Record<
	ContactSector,
	SalesmenHubspotId
> = {
	[ContactSector.administrationPublique]: SalesmenHubspotId.quentin,
	[ContactSector.agenceConseil]: SalesmenHubspotId.quentin,
	[ContactSector.agroAlimentaire]: SalesmenHubspotId.quentin,
	[ContactSector.bailleurs]: SalesmenHubspotId.quentin,
	[ContactSector.banqueAssurance]: SalesmenHubspotId.quentin,
	[ContactSector.btp]: SalesmenHubspotId.quentin,
	[ContactSector.chimiePharma]: SalesmenHubspotId.quentin,
	[ContactSector.collectivite]: SalesmenHubspotId.quentin,
	[ContactSector.energies]: SalesmenHubspotId.quentin,
	[ContactSector.immobilier]: SalesmenHubspotId.quentin,
	[ContactSector.industrie]: SalesmenHubspotId.quentin,
	[ContactSector.loisirs]: SalesmenHubspotId.quentin,
	[ContactSector.informatiqueEtTelecomsESN]: SalesmenHubspotId.quentin,
	[ContactSector.retailTextileHabillement]: SalesmenHubspotId.quentin,
	[ContactSector.superieur]: SalesmenHubspotId.quentin,
	[ContactSector.transportsLogistique]: SalesmenHubspotId.quentin,
};

export const salesmanCalendarUrl: Record<SalesmenAddress, string> = {
	[SalesmenAddress.quentin]: "https://meetings-eu1.hubspot.com/quentin-oustelandt",
	[SalesmenAddress.capucine]: "https://meetings-eu1.hubspot.com/capucine-abele",
	[SalesmenAddress.ph]:
		"https://meetings-eu1.hubspot.com/paul-henri-vanthournout",
	[SalesmenAddress.contact]: "https://meetings-eu1.hubspot.com/capucine-abele",
	[SalesmenAddress.biz]: "https://meetings-eu1.hubspot.com/capucine-abele",
};

export const contactChallengeRanges: Record<ChallengeType, string[]> = {
	[ChallengeType.companies]: [
		"Moins de 50",
		"De 50 à 150",
		"De 150 à 250",
		"Plus de 250",
	],
	[ChallengeType.internal]: [
		"Moins de 250",
		"De 250 à 500",
		"De 500 à 1000",
		"De 1000 à 5000",
		"Plus de 5000",
	],
	[ChallengeType.school]: [
		"Moins de 250",
		"De 250 à 500",
		"De 500 à 1000",
		"De 1000 à 5000",
		"Plus de 5000",
	],
	[ChallengeType.tenant]: [
		"Moins de 250",
		"De 250 à 500",
		"De 500 à 1000",
		"De 1000 à 5000",
		"Plus de 5000",
	],
	[ChallengeType.city]: [
		// should not be used yet. Added for typescript
		"Moins de 250",
		"De 250 à 500",
		"De 500 à 1000",
		"De 1000 à 5000",
		"Plus de 5000",
	],
};

export const smallClientRanges = [
	"Moins de 50",
	"De 50 à 150",
	"De 150 à 250",
	"Moins de 250",
	"Plus de 250",
];

export const bracketSizes: Record<string, string> = {
	"Moins de 50": "< 50",
	"De 50 à 150": "50 à 150",
	"De 150 à 250": "150 à 250",
	"Moins de 250": "< 250",
	"Plus de 250": "250 à 500",
	"De 250 à 500": "250 à 500",
	"De 500 à 1000": "500 à 1 000",
	"De 1000 à 5000": "1 000 à 2 000",
	"Plus de 5000": "2 000 à 5 000",
};

export const readableChallengeType: Record<ChallengeType, string> = {
	[ChallengeType.companies]: "Inter-entreprises",
	[ChallengeType.internal]: "Interne",
	[ChallengeType.school]: "Étudiant",
	[ChallengeType.tenant]: "Locataire",
	[ChallengeType.city]: "Citoyen",
};

export const hubspotOfferTypes: Record<ChallengeType, string> = {
	[ChallengeType.companies]: "Inter-entreprise",
	[ChallengeType.internal]: "Collaborateur",
	[ChallengeType.school]: "Université",
	[ChallengeType.tenant]: "Locataire",
	[ChallengeType.city]: "Citoyen",
};
